import { FocusZone, FocusZoneDirection } from "azure-devops-ui/FocusZone";
import { css } from "azure-devops-ui/Util";
import * as React from "react";
import { NavLink } from "react-router-dom";
import { makeFullUrl } from "../routing";
import "./TileCollection.scss";

export enum TileImageSize {
    /**
     * 4x3 width:height image ratio
     */
    FourThree = "4_3",

    /**
     * 2x1 width:height image ratio
     */
    Standard = "2",

    /**
     * 3x1 width:height image ratio
     */
    Wide = "3",

    /**
     * Don't display an image
     */
    NoImage = "none"
}

export interface ITile {
    description?: string;
    title?: string;
    url?: string;
    imageClassName?: string;
    imageSize?: TileImageSize;
    imageUrl?: string;
}

export interface ITileCollectionProps {
    className?: string;
    tiles: ITile[][];
    useRowSeparators?: boolean;
}

export class TileCollection extends React.Component<ITileCollectionProps> {
    public render(): JSX.Element | null {
        const { className, tiles } = this.props;

        return (
            <FocusZone direction={FocusZoneDirection.Horizontal} includeDefaults={true}>
                <div className={css("tile-collection flex-column", className)}>
                    <div className={css("tile-collection-row flex-wrap flex-row", this.props.className)}>
                        {tiles.map((tileRow) => (
                            tileRow.map((tile) => {
                                let tileContent = (
                                    <div className="tile-collection-tile-content">
                                        {tile.imageSize !== TileImageSize.NoImage && (
                                            <img
                                                className={css(
                                                    "tile-collection-tile-image",
                                                    tile.imageClassName,
                                                    "image-ratio-" + (tile.imageSize || TileImageSize.Standard)
                                                )}
                                                src={tile.imageUrl ?? require("../Images/Thumbnails/noimage.svg")}
                                                alt=""
                                            />
                                        )}
                                        {tile.title &&
                                            <div className={css("tile-collection-tile-header",
                                                !tile.imageUrl ? "tile-collection-tile-header-overlay" : null )}
                                            >
                                                {tile.title}
                                            </div>
                                        }
                                        {tile.description && <div className="tile-collection-tile-description">{tile.description}</div>}
                                    </div>
                                );
                                if (tile.url) {
                                    tileContent = <NavLink to={makeFullUrl(tile.url)}>{tileContent}</NavLink>;
                                }
                                return (
                                    <div className="tile-collection-tile focus-treatment">
                                        {tileContent}
                                    </div>
                                );
                            })
                        ))}
                    </div>
                </div>
            </FocusZone>
        );
    }
}
